import React from 'react';
import { Navigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';

/**
 * GameTypeGuard — 운영사 게임종류 토글 라우트 가드.
 *
 * 운영사(1단계)가 미운영으로 설정한 게임종류의 페이지에 직접 URL로 접근하면
 * 홈('/')으로 리다이렉트한다(UI 우회 차단). 서버측 API 가드(user-api games/sports)가
 * 데이터 차단의 최종 권위이며, 본 가드는 화면 진입 차원의 보강이다.
 *
 * enabledGameTypes 미확정(null=로딩 전/비로그인)이면 통과시킨다 —
 * isGameTypeEnabled 가 null 일 때 true 를 반환하므로 로딩 중 오판/깜빡임이 없다.
 *
 * [2026-10-07 미니게임] 미니게임은 목록을 모를 때 false 다(hooks/useAuth.js GAME_TYPE_DEFAULT_WHEN_UNKNOWN — 기본 미운영).
 *   WHY: 그대로 두면 /minigame 에서 새로고침할 때마다 로그인 확인이 끝나기 전에 홈으로 튕긴다.
 *   그래서 "막을 판정"이 나왔는데 로그인·게임종류 확인이 아직 진행 중이면 그 사이에는 아무것도 그리지 않고 결과를 기다린다.
 *   카지노·슬롯·스포츠는 모를 때 true 라 이 분기에 오지 않는다(종전과 같이 바로 그린다).
 */
const GameTypeGuard = ({ gameType, children }) => {
  const { isGameTypeEnabled, loading } = useAuth();
  if (!isGameTypeEnabled(gameType)) {
    if (loading) return null;
    return <Navigate to="/" replace />;
  }
  return children;
};

export default GameTypeGuard;
